export enum DASH_TYPE_ENUM {
  DASH = 'DASH',
  POINT = 'POINT',
}
